/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM } from 'utils/styles/style_helpers';


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TABS : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)

export default theme => ({
    pervasivemessage: {
        padding: props => props.padding ? replacePXinStringWithEM(`${props.padding}px ${theme.spacing.sides} 0px`) : 'none'
    }
});